import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const LockOpenOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function LockOpenOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M13.01 16.5c0 .55-.45 1-1 1s-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2Z" />
          <path fillRule="evenodd" clipRule="evenodd" d="M8.01 7.5V9H20.5v8.5c0 2.76-2.24 5-5 5h-7c-2.76 0-5-2.24-5-5V9H6V7.5c0-3.31 2.69-6 6-6 2.19 0 4.2 1.19 5.26 3.11l-1.75.96a3.999 3.999 0 0 0-7.5 1.93Zm7.5 13c1.65 0 3-1.35 3-3V11h-13v6.5c0 1.65 1.35 3 3 3h7Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default LockOpenOutlined;